import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Text from '../../components/Text';
import Table from '../../components/Table';
import Card, { DefaultLoadingBodyComponent } from '../../components/Card';
import { useSnackbar } from '../../components/Snackbar';
import establishmentStore from '../../store/establishment';

import * as Controller from './controller';

export default function UserPoints() {
  const snackbar = useSnackbar();
  const currentEstablishment = establishmentStore(state => state.establishment);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  function fetchUsers() {
    if (!currentEstablishment?.cgccpf) return;

    Controller.getUserPoints({
      cnpj: currentEstablishment.cgccpf.replace(/[^\d]+/g, ''),
      setUsers,
      setLoading,
      snackbar,
    });
  }

  useEffect(() => {
    fetchUsers();
  }, [currentEstablishment]);

  return (
    <Row>
      <Col xs={12}>
        <Card
          loading={loading}
          LoadingBodyComponent={() => (
            <DefaultLoadingBodyComponent linesCount={5} perLine={1} />
          )}
          header={
            <Text color="#464E5F" type="header">
              Ranking de pontos
            </Text>
          }
        >
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Text type="label" weight="500">
                    Usuário
                  </Text>
                </th>
                <th>
                  <Text type="label" weight="500">
                    CPF
                  </Text>
                </th>
                <th className="text-right">
                  <Text type="label" weight="500">
                    Total de pontos
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {users.map(item => (
                <tr key={item.cpf}>
                  <td>
                    <Text type="regular">{item.user || 'Não informado'}</Text>
                  </td>
                  <td>
                    <Text type="regular">{item.cpf}</Text>
                  </td>
                  <td className="text-right">
                    <Text type="regular">{item.points}</Text>
                  </td>
                </tr>
              ))}
              {!loading && users.length === 0 && (
                <tr>
                  <td colSpan="3" className="text-center">
                    <Text>Nenhum usuário encontrado</Text>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="d-flex justify-content-end mt-3">
            <Text type="little" color="gray">
              Top {users.length} usuários
            </Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
}
